import { render, staticRenderFns } from "./deleteCollection.vue?vue&type=template&id=4b78ce2d&scoped=true&"
import script from "./deleteCollection.vue?vue&type=script&lang=js&"
export * from "./deleteCollection.vue?vue&type=script&lang=js&"
import style0 from "./deleteCollection.vue?vue&type=style&index=0&id=4b78ce2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78ce2d",
  null
  
)

export default component.exports